<template>
  <v-data-table
    class="elevation-0"
    mobile-breakpoint="0"
    item-key="id"
    :options.sync="studentTableOptions"
    :server-items-length="totalItems"
    :headers="headers"
    :items-per-page="5"
    :items="students"
    @input="$emit('update:selected', $event)"
    :footer-props="footerTable"
    v-bind="this.$attrs"
    loading-text="Đang Tải"
    :loading="load"
  >
    <template v-slot:no-data>
      <div class="my-14 font-weight-bold">
        <div>Hiện tại chưa có Học viên trong danh sách.</div>
        <div>Vui lòng thực hiện thao tác thêm Học viên ở phía trên.</div>
      </div>
    </template>
    <template v-if="propHeaders && propHeaders.length" v-slot:top="{ pagination }">
      <v-data-footer
        :pagination="pagination"
        :options.sync="studentTableOptions"
        :items-per-page-options="[5, 10, 15]"
        items-per-page-text="Số dòng mỗi trang:"
        :page-text="pageText"
      />
    </template>

    <template v-slot:[`header.name`]="{ header }">
      <span class="pl-2">
        {{ header.text }}
      </span>
    </template>
    <template v-slot:[`item.stt`]="{ index }">
      <span>{{ number + index + 1 }}</span>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <card-student-name :student="item" link />
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small class="white--text" v-if="item.status" :color="item.status | statusColor" label>
        <span class="white--text">{{ item.status | status }}</span>
      </v-chip>
    </template>
    <template v-slot:[`item.currentClass`]="{ item }">
      <router-link style="text-decoration: none" :to="'/class/' + (item.currentClass && item.currentClass.id)">
        <span style="color: #0d47a1" v-if="item.currentClass">{{ item.currentClass | getCurrentClass }}</span>
      </router-link>
    </template>
    <template v-slot:[`item.gender`]="{ item }">{{ item.gender | gender }}</template>
    <template v-slot:[`item.dob`]="{ item }">
      <span>{{ item.dob | ddmmyyyy }}</span>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <student-list-actions :id="item.groupStudentId"></student-list-actions>
    </template>
  </v-data-table>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import StudentListActions from '@/modules/tuitionFee/detail-group/StudentListActions.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import { getHeader } from '@/modules/tuitionFee/detail-group/helper/headerTable.js'

export default {
  data() {
    return {
      studentTableOptions: {},
      selected: [],
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' },
      ],
      number: 0,
      load: true,
    }
  },
  props: {
    propHeaders: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    CardStudentName,
    StudentListActions,
  },
  computed: {
    headers() {
      return this.propHeaders && this.propHeaders.length ? this.propHeaders : getHeader(this.groupInfo.category)
    },
    ...mapState('tuitionFeeGroupStudent', ['totalItems', 'students', 'pageText', 'loading', 'studentSearchParams']),
    ...mapGetters('tuitionFeeGroup', ['groupInfo']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số dòng mỗi trang:',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions('tuitionFeeGroupStudent', ['requestPageSettings']),
  },
  filters: {
    getCurrentClass(currentClass) {
      return currentClass == null ? '' : currentClass.title
    },
  },
  watch: {
    studentTableOptions: {
      handler(newOptions, oldOptions) {
        if (this.groupInfo.category) {
          const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
          const pageChanged = newOptions.page !== oldOptions.page
          if (pageChanged || itemPerPageChanged) {
            this.requestPageSettings({
              page: newOptions.page,
              itemsPerPage: newOptions.itemsPerPage,
              defaultId: this.groupInfo.defaultId,
              defaultType: this.groupInfo.defaultType,
              id: this.groupInfo.id,
            })
          }
        }
      },
      deep: true,
    },
    groupInfo() {
      this.requestPageSettings({
        page: this.studentTableOptions.page,
        itemsPerPage: this.studentTableOptions.itemsPerPage,
        defaultId: this.groupInfo.defaultId,
        defaultType: this.groupInfo.defaultType,
        id: this.groupInfo.id,
      })
    },
    students() {
      this.number = (this.studentTableOptions.page - 1) * this.studentTableOptions.itemsPerPage
    },
    loading() {
      this.load = this.loading
    },
  },
}
</script>
